import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http'; // importing the http
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {NgIconsModule} from '@ng-icons/core';
import {
  heroMagnifyingGlassSolid,
  heroChevronRightSolid,
  heroCheckCircleSolid,
} from '@ng-icons/heroicons/solid';

import {heroEnvelope} from '@ng-icons/heroicons/outline';
import {AppComponent} from './app.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {
  CommonModule,
  DatePipe
} from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MaterialModule} from './material.module';
import {AuthModule} from './auth/auth.module';
import {AuthInterceptor} from './core/interceptors/auth.interceptor';
import {SharedModule} from './shared/shared.module';
import {INRModule} from './modules/inr/inr.module';
import {ApplicationsModule} from './modules/applications/applications.module';
import {environment} from "../environments/environment";
import {API_ROUTES, BASE_URL} from "./core/constants/api.const";
import {ApiRoutes} from "../environments/api-routes/api-routes";
import {ErrorHandlingInterceptor} from "./core/interceptors/error.interceptor";
import {MessageService} from "primeng/api";

@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule, CommonModule, SharedModule, ApplicationsModule, INRModule, AuthModule,
    NgbModule, HttpClientModule, FormsModule, ReactiveFormsModule, NgIconsModule.withIcons({
      heroMagnifyingGlassSolid,
      heroChevronRightSolid,
      heroCheckCircleSolid,
      heroEnvelope,
    }), MaterialModule, BrowserAnimationsModule,
  ],
  providers: [
    {provide: BASE_URL, useValue: environment.baseURL+environment.port},
    {provide: API_ROUTES, useValue: ApiRoutes},
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorHandlingInterceptor, multi: true},
    MessageService,
    DatePipe
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
